import styled from "styled-components";

export const DataGridButton = styled.button`
    margin-right: 1rem;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: #0090C1;

    background: none;
    border: 2px solid #0090C1;
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const SubTitle = styled.p`
  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 450;
  color: rgba(55, 73, 87, 0.7);
  font-size: 1.5rem;

  z-index: 2;

  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
`;

export const Button = styled.button`
  position: absolute;
  right: 0%;

  height: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;

  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 900;
  color: #2e933c;

  background: none;
  border: 2px solid #2e933c;
  border-radius: 20px;

  cursor: pointer;

  &:hover {
    background: rgba(55, 73, 87, 0.1);
    transition-duration: 0.1s;
  }

  &:active {
    background: rgba(55, 73, 87, 0.2);
    transition-duration: 0.1s;
  }

  z-index: 3;
`;

export const UserDeleteOptions = styled.a`
    cursor: pointer;

    &:hover{
        opacity: 0.5;
    }
`;

export const UserDeleteOptionsRed = styled(UserDeleteOptions)`
    color: #DB3A34;
`;

export const UserDeleteOptionsGreen = styled(UserDeleteOptions)`
color: #2E933C;
`;